module.exports = "<div class=\"ui negative icon message\">\n  <i class=\"minus circle icon\"></i>\n  <div class=\"content\">\n    <div class=\"header\">\n      Khu vực hạn chế truy cập\n    </div>\n    <p>Vui lòng đăng nhập để tiếp tục.</p>\n\n    <button class=\"ui button\" (click)=\"auth.login()\">Đăng nhập</button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main